import React, { useEffect, useState } from 'react';
import {  QuestionDataForm } from '../../../../../../app/models/Question';
import SelectTwo, { SelectTwoMapperOptions } from '../../../../../../components/SelectTwo';
import { ServiceResponse } from '../../../../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import LazyLoading from '../../../../../../components/LazyLoading';
import useTruckService from '../../../../../../app/services/hooks/useTruckService';
import { TruckDataForm } from '../../../../../../app/models/Truck';

type Props = {
    input: QuestionDataForm; 
    handleChange: (user:any) => void;
    disabled?: boolean
};

const QuestionTruckField = ({ input, handleChange, disabled=false }: Props) => {

    const { allTrucks, fetchingAllTrucks } = useTruckService();

    const [trucks, setTrucks] = useState<TruckDataForm[]>([]);

    useEffect(() => {
        getTrucks();
    }, []);

    const getTrucks = () => {
        allTrucks({
            onSuccess: (response: ServiceResponse) => {
                setTrucks(response.data.trucks);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        });
    };
    

    return fetchingAllTrucks ? (
        <LazyLoading height={300} />
    ) : (
        <div className="mb-5">
            <SelectTwo
                name={'truck'}
                id={`${input.id}`}
                inputValue={input.text}
                options={SelectTwoMapperOptions(trucks)}
                onChange={handleChange}
                placeholder={'Seleccione Tracto'}
                isClearable={true}
                disabled={disabled}
            />
        </div>
    );
};

export default QuestionTruckField;